import { Controller } from "@hotwired/stimulus"
import EasyMDE from "easymde"

export default class extends Controller {
  static values = {
    placeholder: { type: String, default: "Write in markdown..." },
    minHeight: { type: String, default: "200px" },
    simple: { type: Boolean, default: false }
  }

  connect() {
    const toolbar = this.simpleValue
      ? ["bold", "italic", "heading", "|", "unordered-list", "ordered-list", "|", "link", "preview", "guide"]
      : ["bold", "italic", "heading", "heading-smaller", "|",
         "unordered-list", "ordered-list", "|",
         "link", "code", "quote", "|",
         "preview", "side-by-side", "|", "guide"]

    this.editor = new EasyMDE({
      element: this.element,
      spellChecker: false,
      placeholder: this.placeholderValue,
      minHeight: this.minHeightValue,
      autoDownloadFontAwesome: false,
      status: false,
      toolbar: toolbar,
      styleSelectedText: false,
      forceSync: true
    })
  }

  disconnect() {
    if (this.editor) {
      this.editor.toTextArea()
      this.editor = null
    }
  }
}
